import { memo, useEffect, useState, useRef } from 'react'
import { Nav, Navbar } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, Link } from 'react-router-dom'
import { getNavbarContent } from '../../actions/cms'
import config from '../../config/cms'
import LanguageDropdown from '../LanguageDropdown'
import Timer from '../Timer/Timer'
import MenuDropdown from './MenuDropdown'
import UserMenu from './UserMenu'
import '../../styles/components/layout/AppNavbarStyle.scss'
import { usePrevious } from '../../utils'
import isEmpty from '../../utils/isEmpty'
import { getPath } from '../../MultilingualRouter/MultilingualRouter'
import Pages from '../../Enum/Pages'
import SocialLinks from './SocialLinks'
import { setUser } from '../../actions/login'
import { customerGet } from '../../actions/customerAccount'

const AppNavbar = () => {
  const dispatch = useDispatch()

  const lang = useSelector((state) => state.lang.lang)
  const prevLang = usePrevious(lang)
  const loginData = JSON.parse(sessionStorage.getItem('userData'))
  const customerData = useSelector((state) => state.customerAccount?.customer)
  const content = useSelector((state) => state.cms?.navbar)
  const location = useLocation()
  const path = location.pathname
  const prevPath = usePrevious(path)
  const isLoggedIn = loginData?.access_token && customerData
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const navToggleRef = useRef()

  useEffect(() => {
    if (loginData && !customerData) {
      dispatch(setUser(loginData))
      dispatch(customerGet(loginData.customer_id))
    }
  })

  useEffect(() => {
    if (isEmpty(content) || lang !== prevLang) {
      dispatch(getNavbarContent())
    }
  }, [lang, dispatch, prevLang, content])

  useEffect(() => {
    if (path !== prevPath && document.body.classList.contains('menu-open')) {
      navToggleRef.current.click()
    }
  }, [path, prevPath])

  const handleNavToggle = () => {
    if (isMenuOpen) {
      document.body.classList.remove('menu-open')
      setIsMenuOpen(false)
    } else {
      document.body.classList.add('menu-open')
      setIsMenuOpen(true)
    }
  }

  return (
    <div className="header-wrapper">
      <Navbar
        expand="xl"
        className={`header container-xxxl flex-nowrap px-3 py-1 ${isLoggedIn ? 'logged' : 'guest'}-nav-bar`}
      >
        <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={handleNavToggle} ref={navToggleRef} />
        <div className="d-flex align-self-center align-items-center mx-auto">
          <Link to={getPath(Pages.index)} className="navbar-brand cursor-pointer py-0">
            <img
              loading="lazy"
              src={content?.logo?.url ? config.url + content.logo.url : ''}
              className="d-inline-block align-top logo py-0"
              alt={content?.logo?.alternativeText}
            />
          </Link>
          {isLoggedIn && <Timer />}
        </div>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto align-items-xl-center">
            {content?.unlogedLinks?.map((item) =>
              (item?.SubMenuItem?.length ? (
                <MenuDropdown key={item.id} menuItem={item} path={path} />
              ) : (
                <Link
                  className="text-nowrap nav-link"
                  to={item.link?.length > 0 ? item.link : getPath(item.linkId?.urlId)}
                  key={`${item.link}${item.title}`}
                  target={item.link?.length > 0 ? '_blank' : undefined}
                  rel={item.link?.length > 0 ? 'noreferrer nofollow' : undefined}
                >
                  {item.icon && <i className="material-icons mb-0 me-1 align-middle text-primary">{item.icon}</i>}
                  <strong className="nav-link-title text-nowrap">{item.title}</strong>
                </Link>
              )))}
            <LanguageDropdown />
            {!isLoggedIn && (
              <>
                <Link
                  className="btn btn-outline-primary text-nowrap mx-3 mx-xl-0 mt-3 mt-xl-0 font-sm guest-btn"
                  to={getPath(Pages.loginPage)}
                >
                  <i className="material-icons me-2 align-middle">lock</i>
                  <strong className="nav-link-title text-nowrap">{content?.login}</strong>
                </Link>
                <Link
                  className="btn btn-primary mt-3 mt-xl-0 mx-3 ms-xl-2 me-xl-0 text-nowrap py-xl-2 font-sm guest-btn"
                  to={getPath(Pages.registerPage)}
                >
                  <i className="material-icons me-2 align-middle">vpn_key</i>
                  <strong className="nav-link-title text-nowrap">{content?.register}</strong>
                </Link>
              </>
            )}
          </Nav>
          <div className="header-social-links d-xl-none">
            <SocialLinks />
          </div>
        </Navbar.Collapse>
        {isLoggedIn && <UserMenu content={content} path={path} />}
      </Navbar>
    </div>
  )
}

export default memo(AppNavbar)
